import React from 'react';

import { useAppSelector } from '~/hooks/store';
import { selectRole, selectScopes } from '~/store/admin/selectors';

import { defineAbility } from './ability';
import { AbilityContext } from './context';

interface Props {
  children: React.ReactNode;
}

export const AbilityProvider: React.FC<Props> = ({ children }) => {
  const role = useAppSelector(selectRole);
  const scopes = useAppSelector(selectScopes);
  const ability = React.useMemo(() => defineAbility({ role, scopes: scopes ?? [] }), [role, scopes]);

  return <AbilityContext value={ability}>{children}</AbilityContext>;
};
